import Vue from 'vue'
import Router from 'vue-router'

import Home from '../../components/Home.vue'
import Dashboard from '../../components/Dashboard.vue'
import AfterApproval from '../../components/AfterApproval'
import Login from '../../components/Login.vue'
import UserUpdate from '../../components/User/UserUpdate.vue'
import CompanyUsers from '../../components/User/CompanyUsers.vue'
import ChangePassword from '../../components/User/ChangePassword.vue'
import ResetPassword from '../../components/ResetPassword.vue'
import Invite from '../../components/User/Invite.vue'
import Feedback from '../../components/User/Feedback.vue'
import Register from '../../components/Register.vue'
import RegisterInvite from '../../components/RegisterInvite.vue'
import DocumentCreate from '../../components/Document/DocumentCreate.vue'
import DocumentApproval from '../../components/Document/DocumentApproval.vue'
import CompanyEmailList from '../../components/User/CompanyEmailList.vue'

import { store } from '../../components/_store'

import * as jwt from 'jsonwebtoken'

Vue.use(Router)

export const router = new Router({
    // IMPORTANT: the '*' path will catch all routes that aren't defined here, and route back to home
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                authorize: []
            }
        },
        {
            path: '/afterapproval',
            name: 'After Approval',
            component: AfterApproval
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/reset-password',
            name: 'Reset Password',
            component: ResetPassword
        },
        {
            path: '/user/userupdate',
            name: 'Update User',
            component: UserUpdate,
            meta: {
                authorize: []
            }
        },
        {
            path: '/user/distribution-lists',
            name: 'Distribution Lists',
            component: CompanyEmailList,
            meta: {
                authorize: ['Admin']
            }
        },
        {
            path: '/user/CompanyUsers',
            name: 'Company Users',
            component: CompanyUsers,
            meta: {
                authorize: ['Admin']
            }
        },
        {
            path: '/user/changepassword',
            name: 'Change Password',
            component: ChangePassword,
            meta: {
                authorize: []
            }
        },
        {
            path: '/user/invite',
            name: 'Invite',
            component: Invite,
            meta: {
                authorize: ['Admin']
            }
        },
        {
            path: '/feedback',
            name: 'Feedback',
            component: Feedback,
            meta: {
                authorize: ['Admin']
            }
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/registerinvite',
            name: 'RegisterInvite',
            component: RegisterInvite
        },
        {
            path: '/documents/create',
            name: 'Initiate Approval',
            component: DocumentCreate,
            meta: {
                authorize: ['Admin']
            }
        },
        {
            path: '/documents/approval',
            name: 'Document Approval',
            component: DocumentApproval
        },
        {
            path: '*',
            name: 'Everything Else',
            redirect: '/'
        }
    ],
    mode: 'history'
})

function clearAndRedirect(next) {
    localStorage.clear()
    store.dispatch('authentication/logout')

    return next({
        path: '/'
    })
}

router.beforeEach((to, from, next) => {
    //beforeEach route code
    const { authorize } = to.meta

    if (authorize) {
        let mToken = localStorage.getItem('user')
        if (!store.state.authentication.loggedInUser || !mToken) {
            // not logged in so redirect to login page with the return url
            return clearAndRedirect(next)
        }

        // Check jwt not expired
        // Parts copied/pasted from jsonwebtoken's verify
        let timestamp = Math.floor(Date.now() / 1000)
        let decodedToken = jwt.decode(JSON.parse(mToken))
        if (
            !decodedToken.exp ||
            (decodedToken.exp && typeof decodedToken.exp !== 'number') ||
            (decodedToken.exp && decodedToken.exp <= timestamp)
        ) {
            // Clear data and redirect to login if:
            // 1) no expiry
            // 2) expiry field isn't a number
            // 3) expiry field is in the past
            return clearAndRedirect(next)
        }
        // check if route is restricted by role
        if (
            authorize.length > 0 &&
            !store.state.authentication.loggedInUser.role
                .split(',')
                .sort()
                .includes(authorize.sort().join(','))
        ) {
            store.commit('setSnackbarFromRouter')
            return next({
                path: '/'
            })
        }
    }
    next()
})
